import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Month } from './Month';
import { DateUtils } from '../../utils';
import { Provider } from './Context';
import { CalendarTypeProp, CalendarTypePropDefault } from '../../models';

export const Calendar = ({
    displayMonth,
    minDate,
    maxDate,
    onSelect,
    dates,
    selectedDate,
    isDatesRangeShown,
    type,
}) => {
    const { t } = useTranslation();
    const titleFormat = t('calendar.dateTitleFormat');

    const provider = {
        displayMonth,
        minDate,
        maxDate,
        onSelect,
        dates,
        selectedDate,
        isDatesRangeShown,
        type,
        weekStartsOn: parseInt(t('calendar.startDay'), 10),
        countryHolidays: DateUtils.parseArrayOfDates(t('calendar.holidays.country.main')),
        regionHolidays: DateUtils.parseArrayOfDates(t('calendar.holidays.region.main')),
    };
    const title = DateUtils.formatDate(provider.displayMonth, titleFormat);

    return (
        <Provider value={provider}>
            <div className="odf-calendar">
                <div className="odf-calendar-title">{title}</div>
                <Month displayMonth={provider.displayMonth} weekStartsOn={provider.weekStartsOn} />
            </div>
        </Provider>
    );
};

Calendar.propTypes = {
    onSelect: PropTypes.func.isRequired,
    dates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    displayMonth: PropTypes.instanceOf(Date),
    isDatesRangeShown: PropTypes.bool.isRequired,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    selectedDate: PropTypes.instanceOf(Date),
    type: CalendarTypeProp,
};

Calendar.defaultProps = {
    dates: [],
    displayMonth: DateUtils.getToday(),
    minDate: DateUtils.getToday(),
    maxDate: DateUtils.getLastValidDay(),
    selectedDate: null,
    type: CalendarTypePropDefault,
};
